export const pageInstructorData = [
    {
        id: 1,
        name: "SDR",
        value: "sdr"
    },
    {
        id: 2,
        name: "PDM",
        value: "pdm"
    }
]